<template>
<div class="tab-page">
	<form @submit.prevent="nextStep" ref="form">
		<div id="steps">
			<div
				v-for="(step, index) in data.steps"
				:key="'step-' + index"
				class="step"
			>
				<div class="step-title" @click="step.visible=!step.visible">
					<div class="container">
						<div class="content">
							<div class="step-title-inner">
								<span>{{$t('step')}} {{index+1}}</span>
								<span class="add-more remove" @click="remove(step)" v-show="count > data.minSteps">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16.2A7.2 7.2 0 1 1 16.2 9 7.22 7.22 0 0 1 9 16.2zm-.9-6.3H4.5V8.1h9v1.8H8.1z"/></svg>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="step-inner" v-show="step.visible">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label :for="'step-length-' + (index+1)">
										<span class="info" :data-tooltip="$t('step-length-help')">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M8.1 4.5h1.8v1.8H8.1zm0 3.6h1.8v5.4H8.1zm.9 8.1A7.2 7.2 0 1 1 16.2 9 7.22 7.22 0 0 1 9 16.2zM9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9z"/></svg>
										</span>
										{{$t('step-length-?')}}
									</label>
									<div class="element">
										<div class="flex">
											<input type="number" :id="'step-length-' + (index+1)" v-model="step.length" placeholder=" " min="0" step="any">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label :for="'feeding-' + (index+1)">
										<span class="info" :data-tooltip="$t('step-feeding-help')">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M8.1 4.5h1.8v1.8H8.1zm0 3.6h1.8v5.4H8.1zm.9 8.1A7.2 7.2 0 1 1 16.2 9 7.22 7.22 0 0 1 9 16.2zM9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9z"/></svg>
										</span>
										{{data.feedingLabel}}
									</label>
									<div class="element">
										<div class="flex">
											<input type="number" min="0" step="any" :id="'feeding-' + (index+1)" v-model="step.feeding" placeholder=" ">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="showNeedlesNumber" class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label :for="'production-speed-' + (index+1)">
										{{$t('production-speed-?')}}
									</label>
									<div class="element">
										<div class="flex">
											<input type="number" required @input="checkSpeedValidity" min="0" step="any" :id="'production-speed-' + (index+1)" v-model="step.productionSpeed" placeholder=" ">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field" v-if="showDrafts">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label :for="'draft-' + (index+1) + '-0'">
										<span class="info" :data-tooltip="$t('step-draft-help')">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M8.1 4.5h1.8v1.8H8.1zm0 3.6h1.8v5.4H8.1zm.9 8.1A7.2 7.2 0 1 1 16.2 9 7.22 7.22 0 0 1 9 16.2zM9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9z"/></svg>
										</span>
										{{$t('draft')}}
									</label>
									<div
										v-for="(draft, index2) in step.drafts"
										:key="'draft-' + index2"
										class="element"
									>
										<div class="flex">
											<input type="number" min="0" step="any" :id="'draft-' + (index+1) + '-' + index2" v-model="step.drafts[index2]" placeholder=" ">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="step-title"  id="add-step" @click="add()" v-show="count < data.maxSteps">
				<div class="container">
					<div class="content">
						<div class="step-title-inner">
							<span>{{$t('add-step')}}</span>
							<span class="add-more add">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M9,16.2A7.2,7.2,0,1,1,16.2,9,7.22,7.22,0,0,1,9,16.2ZM9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Zm.9,4.5H8.1V8.1H4.5V9.9H8.1v3.6H9.9V9.9h3.6V8.1H9.9Z"/></svg>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
	<hr>
	<div class="container">
		<div class="content">
			<button class="" @click="nextStep">{{$t('apply')}}</button>
		</div>
	</div>
</div>
</template>

<script>
export default {
	props: ['data'],
	data() {
		return {
		}
	},
	computed: {
		showNeedlesNumber() {
			let rst = false;
			switch (this.data.yarnType) {
				case 'fancy-yarn':
					rst = false;
					break;
				case 'ribbon-yarn':
					rst = true;
					break;
				case 'soft-knit-yarn':
					rst = true;
					break;
			}
			return rst;
		},
		showDrafts() {
			let rst = true;
			switch (this.data.effectType) {
				case 'roving':
					rst = true;
					break;
				case 'yarn':
					rst = false;
					break;
			}
			return rst;
		},
		count() {
			return this.data.steps.length;
		},
	},
	methods: {
		add() {
			if (this.count < this.data.maxSteps) {
				let step = {
					number: this.count + 1,
					visible: true,
					length: 100,
					feeding: '',
					drafts: [],
					productionSpeed: 1,
				};
				for (let i = 0; i < this.data.effects.length; i++) {
					step.drafts.push('');
				}

				this.$set(this.data.steps, this.data.steps.length, step);
			}
		},
		remove(step) {
			if (this.count > this.data.minSteps) {
				this.$delete(this.data.steps, this.data.steps.indexOf(step));
			}
		},
		nextStep() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			this.$parent.enableTab(3);
		},
		checkSpeedValidity(event){
			const input = event.target;
			if (input.value == 0) {
				input.setCustomValidity(this.$t('speed-validity'));
			} else {
				// input is fine -- reset the error message
				input.setCustomValidity('');
			}
		}
	}
}
</script>

<style scoped>
#steps {
	padding-bottom: 1.6rem;
}

.step-title {
	display: flex;
	align-items: center;
    background: #fff;
    height: 5.6rem;
    position: relative;
    text-transform: uppercase;
}

.step-title {
    border-bottom: .1rem solid #ddd;
}

.step-title-inner {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

#add-step {
	color: var(--primary_color);
	text-decoration: underline;
}

.step-inner {
	border-bottom: .1rem solid #ddd;
}
</style>